/**
 *  Filter specific configuration, e.g.
 *  default values and name-value mapping
 */

import type { FeatureGroupIdType, OrderByType, SortOrderType, ExtraFeaturesType } from '@/types/schemaTypes';
import type { FeatureGroupFiltersType } from './featureGroups';

export default {
  SEARCH_MODES: {
    RENTAL: 'rental',
    SALE: 'sale',
  } as Record<string, keyof FeatureGroupFiltersType>,
  FILTER_LIMITS: {
    AREA_MIN: 0,
    AREA_MAX: 200,
    SITE_AREA_MIN: 0,
    SITE_AREA_MAX: 100000,
    TOTAL_AREA_MIN: 0,
    TOTAL_AREA_MAX: 10000,
    PRICE_MIN: 0,
    PRICE_MAX: 1500000,
    YEAR_MIN: 1900,
    YEAR_MAX: new Date().getFullYear() + 1,
    RENT_MIN: 0,
    RENT_MAX: 10000,
  },
  FILTER_DEFAULTS: {
    order: 'desc' as SortOrderType,
    orderBy: 'created' as OrderByType,
    limit: 50,
    featureGroup: 'apartment' as FeatureGroupIdType,
  },
  FILTER_MAPPING: {
    priceRange: ['priceMin', 'priceMax'],
    rentRange: ['rentMin', 'rentMax'],
    livingArea: ['livingAreaMin', 'livingAreaMax'],
    siteArea: ['siteAreaMin', 'siteAreaMax'],
    totalArea: ['totalAreaMin', 'totalAreaMax'],
    yearRange: ['yearMin', 'yearMax'],
    numberOfRooms: ['numberOfRooms'],
    condition: ['condition'],
  },
  LOCATION_FILTERS: ['cityId', 'districtId', 'streetId', 'regionId'],
  EXTRA_FEATURES: {
    elevator: 'Hissi',
    sauna: 'Oma sauna',
    balcony: 'Parveke',
    shore: 'Oma ranta',
    sharedShore: 'Rantaoikeus',
  } as Record<ExtraFeaturesType, string>,
  FILTER_KEYS: [
    'livingAreaMin',
    'livingAreaMax',
    'siteAreaMin',
    'siteAreaMax',
    'totalAreaMin',
    'totalAreaMax',
    'priceMax',
    'priceMin',
    'rentMax',
    'rentMin',
    'yearMin',
    'yearMax',
    'agentId',
    'companyId',
    'showingIn',
    'siteOwnership',
    'has360',
    'limit',
  ],
  SHOWINGS: {
    all: 0,
    near: 3,
    far: 7,
  },
  SITE_OWNERSHIP: {
    all: {
      id: 'all',
      name: '',
    },
    owned: {
      id: 'o',
      name: 'oma',
    },
    rented: {
      id: 'v',
      name: 'vuokra',
    },
  },
};
